import { InlineError, Input } from 'avo-ui'
import ModalForm from 'components/commons/modal-form'

export const FormPointDetail = ({
    show,
    onHideForm,
    dataPointDetail,
    isLoading,
    isAddForm,
    onChangeForm,
    errorForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-[500px] overflow-auto'}
            show={show}
            onHide={onHideForm}
            title={`${isAddForm ? 'Add' : 'Reduce'} Point`}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Nilai Point</div>
                    <Input
                        type={'number'}
                        className={'flex-1'}
                        name={'amount'}
                        placeholder={'Masukkan total point'}
                        value={dataPointDetail?.amount}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.amount} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Deskripsi</div>
                    <Input
                        type={'text-area'}
                        className={'flex-1'}
                        name={'description'}
                        placeholder={'Masukkan description'}
                        value={dataPointDetail?.description}
                        row={5}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.description} />
                </div>
            </div>
        </ModalForm>
    )
}
